module.exports = __webpack_public_path__ + "img/zadacha1.495f75ff.png";